export function toTitleCase(value) {
  let result = value.replace(/([^\W_]+[^\s-]*) */g, txt =>
    txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  );

  // Certain minor words should be left lowercase unless
  // they are the first or last words in the string
  for (const word of ['A', 'An', 'The', 'And', 'But', 'Or', 'For', 'Nor', 'As', 'At',
    'By', 'For', 'From', 'In', 'Into', 'Near', 'Of', 'On', 'Onto', 'To', 'With'])
    result = result.replace(new RegExp('\\s' + word + '\\s', 'g'), txt => txt.toLowerCase());

  // Certain words such as initialisms or acronyms should be left uppercase
  for (const word of ['Id', 'Tv'])
    result = result.replace(new RegExp('\\b' + word + '\\b', 'g'), word.toUpperCase());

  return result;
}
